import setCaptchaVisibilityFactory from '../landing/set-captcha-visibility';

export default function (ctrl) {
	ctrl.setCaptchaVisibility = setCaptchaVisibilityFactory(ctrl);
	return function () {
		if (ctrl.Form.$valid) {
			var params = {
				body: {
					email: ctrl.Formdata.email
				}, headers: {
					captcha: ctrl.captchaResponse
				}
			};

			ctrl.showBlockedUserDisclaimer = false;

			ctrl.BaseService.createPromise('postForgottenEmail', params)
				.then(function (response) {
					ctrl.$state.go('forgotPassword.reminderSent');
					ctrl.setCaptchaVisibility(response);
				}).catch(function (error) {
					if (error.status == '400') {
						ctrl.$state.go('forgotPassword.errorSend');
					} else if (error.status == '423') {
						ctrl.showBlockedUserDisclaimer = true;
					}
					ctrl.setCaptchaVisibility(error);
				});
		}
	};
};
